export default __webpack_public_path__ + "static/media/contact.731271e6.png";